"use client";

import React, { useEffect, useRef } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

import DynamicImage from "@/components/DynamicImages/DynamicImage";
import financingImg1 from "@/assets/images/static/financingImg1.webp";
import financingImg2 from "@/assets/images/static/financingImg2.png";
import financingImg3 from "@/assets/images/static/financingImg3.png";
import financingImg4 from "@/assets/images/static/financingImg4.png";
import financingImg5 from "@/assets/images/static/financingImg5.png";
import financingImg6 from "@/assets/images/static/financingImg6.png";
import FinancingServicesBanner from "@/assets/images/static/financingServicesBanner.webp";

const FinancingPage = () => {
  const offersRef = useRef(null);
 const searchParams = useSearchParams();
  useEffect(() => {
    const financeType = searchParams.get("type");
    if (financeType === "wellsFargo" && offersRef.current) {
      const elementTop = offersRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementTop - 100,
        behavior: "smooth",
      });
    }
  }, [searchParams]);

  return (
    <div className="container-fuild max-w-full ">
      <div className="container mx-auto ">
        <section className="bg-[#F1F1F1] text-[#0B223C]   mx-auto  md:h-full ">
          <div className="container relative h-full flex md:flex-col">
            <div className="flex-1 relative">
              <div className=" absolute top-0 bottom-0 right-[-50px] flex flex-col justify-center slg:right-[-15px] md:relative md:right-0 md:top-auto md:bottom-auto md:flex md:justify-center md:items-center md:px-5 md:py-7 ">
                <h1 className="text-[48px] leading-[52px] mb-[14px] font-semibold lg:text-[36px] lg:leading-normal lg:m-0">
                  Financing Services
                </h1>
                <h4 className="text-[16px] font-normal lg:text-[15px] max-w-[248px] md:max-w-full">
                  We offer financing plans that suit your needs.
                </h4>
              </div>
            </div>
            <div className="banner-bg-static relative h-full min-h-[22.29vw] flex-[1.35] 2xl:min-h-[428px] md:min-h-[290px]">
              <DynamicImage
                src={FinancingServicesBanner}
                fill
                className="object-cover"
              />
            </div>
          </div>
        </section>
      </div>
      <div className=" max-w-1440 px-5 container  p-0 lg:px-0">
        <Carousel
          opts={{ align: "start" }}
          className="w-full pt-[70px] lg:pt-[30px] lg:px-4 lg:pb-[58px]"
        >
          <CarouselContent className="p-2">
            <CarouselItem className="basis-1/3 m-0 mlg:basis-1/2 md:basis-8/12 sm:basis-10/12  xsm:basis-full">
              <div className="p-4 h-full">
                <div className="bg-white h-full border-0 rounded-[30px] p-[22px] shadow-financingCard">
                  <div className=" mb-3 ">
                    {/* <DynamicImage
                      src={financingImg3}
                      className=" w-auto h-[40px] object-contain"
                      alt="Authorized Dealer Badge"
                    /> */}
                  </div>
                  <div className="mb-[14px]">
                    <h3 className="text-[16px] font-semibold leading-[21px] mb-[15px] text-[#1D1D1F] ">
                      <span className=" text-[25px] leading-[28px] inline-block font-bold">Wells Fargo Financing</span>
                    </h3>
                    <p className="text-[#374151] mb-3 text-[12px] leading-[19px]">
                      Buy today, pay over time with the Airport Appliance Credit
                      card, issued with approved credit by Wells Fargo Bank,
                      N.A.
                    </p>
                    <p className="text-[#374151] text-[12px] leading-[19px] mb-3">
                      With special financing from Wells Fargo, you can enjoy
                      more purchasing power today and the convenience of monthly
                      payments to help your budget. Plus, you&apos;ll have
                      available credit for future purchases —no need to complete
                      another application.
                    </p>
                    <p className="text-[#374151] text-[12px] font-medium leading-[19px] mb-3">
                      
                        See below for full financing terms*
                    
                    </p>
                  </div>
                  <div className="flex gap-x-4 gap-y-2 flex-wrap">
                    <Link
                      href="https://retailservices.wellsfargo.com/ahapp/init-app?m=2176016467&l=en_US"
                      target="_blank"
                      className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                    >
                      Apply Today
                    </Link>
                  </div>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem className="basis-1/3 m-0 mlg:basis-1/2 md:basis-8/12 sm:basis-10/12 xsm:basis-full">
              <div className="p-4 h-full">
                <div className="bg-white h-full border-0 rounded-[30px] p-[22px] shadow-financingCard">
                  <div className=" mb-3 ">
                    <DynamicImage
                      src={financingImg5}
                      className=" w-auto h-[40px] object-contain"
                      alt="Authorized Dealer Badge"
                    />
                  </div>
                  <div className="mb-[14px]">
                    <h3 className="text-[16px] font-semibold leading-[21px] mb-[15px] text-[#1D1D1F] ">
                      Synchrony Financing
                    </h3>
                    <p className="text-[#374151] mb-3 text-[12px] leading-[19px]">
                      Take advantage of our special promotional financing and
                      everyday benefits by applying today.
                    </p>
                    <p className="text-[#374151] text-[12px] leading-[19px]">
                      Shop smarter and save more with our retail credit card.
                      It&apos;s the ultimate way to get more out of every
                      purchase and make your money go further.
                    </p>
                  </div>
                  <div className="flex gap-x-4 gap-y-2 flex-wrap">
                    <Link
                      href="https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=3CFA7859F753366BE02E1E21C94C49774DC4EEC45262EB74&client=Airport%20Appliance"
                      target="_blank"
                      className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                    >
                      Apply Today
                    </Link>
                  </div>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem className="basis-1/3 m-0 mlg:basis-1/2 md:basis-8/12 sm:basis-10/12 xsm:basis-full">
              <div className="p-4 h-full">
                <div className="bg-white h-full border-0 rounded-[30px] p-[22px] shadow-financingCard">
                  <div className=" mb-3 ">
                    <DynamicImage
                      src={financingImg4}
                      className=" w-auto h-[40px] object-contain"
                      alt="Authorized Dealer Badge"
                    />
                  </div>
                  <div className="mb-[14px]">
                    <h3 className="text-[16px] font-semibold leading-[21px] mb-[15px] text-[#1D1D1F] ">
                      Pay at Your Own Pace{" "}
                    </h3>
                    <p className="text-[#374151] mb-3 text-[12px] leading-[19px]">
                      Choose from more intelligent payment options—like 4
                      interest-free payments or monthly payments.{" "}
                    </p>

                    <p className="text-[#374151] mb-3 text-[12px] leading-[19px]">
                      Affirm offers payment options, subject to an eligibility
                      check, and may not be available in all states. Options
                      depend on your purchase amount, and a down payment may be
                      required.{" "}
                    </p>
                    <p className="text-[#374151] text-[12px] leading-[19px] font-medium">
                      Choose Affirm at checkout*{" "}
                    </p>
                  </div>
                  <div className="flex gap-x-4 gap-y-2 flex-wrap">
                    <Link
                      href="https://www.affirm.com/"
                      target="_blank"
                      className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                    >
                      Learn More{" "}
                    </Link>
                  </div>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem className="basis-1/3 m-0 mlg:basis-1/2 md:basis-8/12 sm:basis-10/12 xsm:basis-full">
              <div className="p-4 h-full">
                <div className="bg-white h-full border-0 rounded-[30px] p-[22px] shadow-financingCard">
                  <div className=" mb-3 ">
                    <DynamicImage
                      src={financingImg6}
                      className=" w-auto h-[40px] object-contain max-w-[136px]"
                      alt="Authorized Dealer Badge"
                    />
                  </div>
                  <div className="mb-[14px]">
                    <h3 className="text-[16px] font-semibold leading-[21px] mb-[15px] text-[#1D1D1F] ">
                      Progressive Leasing
                    </h3>
                    <p className="text-[#374151] mb-3 text-[12px] leading-[19px]">
                      Progressive Leasing is tailored for those with
                      less-than-perfect credit, meaning our decision to approve
                      you for a lease is based on more than simply your credit
                      score.
                    </p>

                    <p className="text-[#374151] mb-3 text-[12px] leading-[19px]">
                      90-Day Purchase Options: Standard agreement offers 12
                      months to ownership. 90-day purchase options cost more
                      than the retailer&apos;s cash price (except 3-month option
                      in CA).
                    </p>
                    <p className="text-[#374151] text-[12px] leading-[19px] font-medium">
                      To cancel lease or purchase early call 877-898-1970*
                    </p>
                  </div>
                  <div className="flex gap-x-4 gap-y-2 flex-wrap">
                    <Link
                      href="https://approve.me/s/airporthomeappliance/96289#/marketing"
                      target="_blank"
                      className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                    >
                      Apply Now
                    </Link>
                    <Link
                      href="https://www.flowcode.com/page/progleasingterms"
                      target="_blank"
                      className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </CarouselItem>
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>
      <div ref={offersRef} className="container-fuild max-w-full bg-[#ffffff] mx-auto px-4 py-[58px] lg:py-[30px] border-b border-b-[#D2D2D7] pb-[94px]">
        <section className=" container max-w-1440 px-7 1440:px-4 1440:w-full lg:px-0">
          <h3 className="text-[32px] leading-[48px] font-bold mb-[48px] lg:text-[28px] lg:leading-[34px] ">
            *Wells Fargo Special Financing Offers:
          </h3>
          {/* <div className="flex  items-center bg-financingCardBg rounded-[15px] overflow-hidden pt-[46px] pb-[50px] pl-[106px] pr-[20px] lg:px-[30px] slg:flex-col-reverse slg:items-start slg:py-[30px]">
            <div className="flex-1 ">
              <div className="text-white  ">
                <h3 className=" text-[30px]  font-bold slg:text-[24px] ">
                  0% Interest for 24 months
                </h3>
                <h4 className=" text-[24px] font-semibold  slg:text-[18px]">
                  on select luxury brands
                </h4>
                <p className="pt-2 pb-5 text-[14px] leading-[20px] max-w-[899px]">
                  The Airport Home Appliance credit card is issued by the Wells
                  Fargo Bank, N.A. Special terms apply to qualifying Purchases
                  of $4,999 & up or more charged with approved credit.
                </p>
                <div className="flex gap-y-2 gap-x-[15px] flex-wrap ">
                  <Link
                    href="https://retailservices.wellsfargo.com/ahapp/init-app?m=2176016467&l=en_US"
                    target="_blank"
                    className="bg-[#FBC600] text-[#0C2340] py-[9px] px-5 rounded-full text-[14px] leading-[20px]"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex-1 max-w-[257px] flex justify-center items-center slg:max-w-[156px] slg:mb-4">
              <DynamicImage
                src={financingImg1}
                className="w-full h-full max-w-[177px] object-contain slg:max-w-full"
                alt="Airport Home Appliance Logo"
              />
            </div>
          </div> */}
          <div className="flex gap-x-[30px] gap-y-[15px] lg:flex-col">
            <ul className="flex-1 max-w-[680px] grid gap-[30px] min-w-[604px] lg:max-w-full lg:min-w-0">
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#EC273C] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    6
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      Special Financing1
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-center">
                  Eligible for appliance purchases<br></br> of $499+
                </div>
              </li>
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#C1051A] w-[68px] text-[54px] leading-[54px]  text-center font-bold  mob:text-[40px] mob:leading-[48px] mob:w-[44px]">
                    12
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      Special Financing1
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-center">
                  Eligible for appliance purchases<br></br> of $599+
                </div>
              </li>
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#7B1D1C] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    18
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      Special Financing1
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t mob:border-l-0 mob:pt-[10px] mob:pl-0">
                  Eligible for appliance purchases<br></br> of $999+
                </div>
              </li>
              {/* <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col border-2 border-[#FFCB05]">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#1E63AD] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    18
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      0% APR Financing 2
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-start flex-col">
                  <p>For appliance purchases of $4,999+</p> 
                  <span className=" text-[12px]">(Only for Dacor /
                    JennAir / Monogram / Signature Kitchen Suite / Thermador)</span>
                </div>
              </li> */}
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col border-2 border-[#FFCB05]">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#1E63AD] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    24
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      0% APR Financing 2
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-start flex-col">
                  <p>For appliance purchases of $4,999+</p>
                  <span className=" text-[12px]">(Only for Dacor /
                  JennAir / Monogram / Signature Kitchen Suite / Thermador)</span>
                </div>
              </li>
            </ul>
            <div className="text-[#374151] text-[14px] flex-1">
              <p className="mb-[10px]">
                <b>01.</b> Subject to approved credit
                {/* <Link href="tel:+18663044449" aria-label="call +18663044449">
                  <span className="text-[#0070C9]">1-800-431-5921</span>
                </Link>
                , press 1 to purchase using promotional financing* */}
              </p>
              <p className="mb-[10px]">
                <b>02.</b> The Airport Home Appliance credit card is issued by the Wells Fargo Bank, N.A. Special terms
apply to qualifying Purchases of $4,999 & up or more charged with approved credit. The special
terms APR will continue to apply until all qualifying purchases are paid in full. The monthly
payment for this purchase will be the amount that will pay for the purchase in full equal
payments during the promotional (Special terms) period. The APR for purchases will apply to
certain fees such as late payments fee or if you use the card for other transactions. For new
accounts, the APR for purchases is 28.99% if you are charged interest in any billing cycle, the
minimum interest charge will be $1.00. This information in accurate as of 05/01/2025 and is
subject to change. For current information, call us at 1-800-431-5921.
              </p>
              <div className="mt-[15px] flex items-center justify-center">
                <Link
                  href="https://retailservices.wellsfargo.com/ahapp/init-app?m=2176016467&l=en_US"
                  target="_blank"
                  className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="container-fuild max-w-full bg-[#ffffff] mx-auto px-4 py-[58px] lg:py-[30px] border-b border-b-[#D2D2D7] pb-[94px]">
        <section className=" container max-w-1440 px-7 1440:px-4 1440:w-full lg:px-0 ">
          <h3 className="text-[32px] leading-[48px] font-bold mb-[25px] lg:text-[28px] lg:leading-[34px] ">
            Synchrony Special Financing Offers:
          </h3>
          {/* <div className="flex  items-center bg-financingCardBgBlue rounded-[15px] overflow-hidden pt-[46px] pb-[50px] pl-[106px] pr-[20px] lg:px-[30px] slg:flex-col-reverse slg:items-start slg:py-[30px]">
            <div className="flex-1 ">
              <div className="text-white  ">
                <h3 className=" text-[30px]  font-bold slg:text-[24px] max-w-[466px]">
                  No Interest if paid in full within 6, 12, 18 or 24 Months*{" "}
                </h3>

                <p className="pt-2 pb-5 text-[14px] leading-[20px] max-w-[899px]">
                  *On qualifying in-store purchases made with your Synchrony
                  Home credit card. Interest will be charged to your account
                  from the purchase date if the promotional balance is not paid
                  in full within 6, 12, 18 or 24 months. Minimum monthly
                  payments required.
                </p>
                <div className="flex gap-y-2 gap-x-[15px] flex-wrap ">
                  <Link
                    href="https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=3CFA7859F753366BE02E1E21C94C49774DC4EEC45262EB74&client=Airport%20Appliance"
                    target="_blank"
                    className="bg-[#FBC600] text-[#0C2340] py-[9px] px-5 rounded-full text-[14px] leading-[20px]"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex-1 max-w-[257px] flex justify-center items-center slg:max-w-[156px] slg:mb-4">
              <DynamicImage
                src={financingImg2}
                className="w-full h-full max-w-[177px] object-contain slg:max-w-full"
                alt="Airport Home Appliance Logo"
              />
            </div>
          </div> */}
          <div className="flex gap-x-[30px] gap-y-[15px]  pt-[56px] lg:flex-col lg:pt-[30px]">
            <ul className="flex-1 max-w-[680px] grid gap-[30px] min-w-[604px] lg:max-w-full lg:min-w-0">
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#69E6E5] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    6
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                     Special Financing*
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-center">
                  Eligible for appliance purchases<br></br> of $499+
                </div>
              </li>
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#49C6CC] w-[68px] text-[54px] leading-[54px]  text-center font-bold  mob:text-[40px] mob:leading-[48px] mob:w-[44px]">
                    12
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      Special Financing*
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-center">
                  Eligible for appliance purchases<br></br> of $599+
                </div>
              </li>
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#217D8D] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    18
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      Special Financing*
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t mob:border-l-0 mob:pt-[10px] mob:pl-0">
                  Eligible for appliance purchases<br></br> of $999+
                </div>
              </li>

              {/* <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col border-2 border-[#FFCB05]">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#1E63AD] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    18
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      0% APR Financing*
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-start flex-col">
                  <p>For appliance purchases of $4,999+</p>
                   <span className="text-[13px]">(Only for Dacor /
                    JennAir / Monogram / Signature Kitchen Suite / Thermador)</span>
                </div>
              </li> */}
              <li className="flex shadow-financingMonthCard rounded-20 p-[15px]  mob:flex-col border-2 border-[#FFCB05]">
                <div className="flex gap-[14px] py-[6px] items-center min-w-[277px]  smd:min-w-[245px]">
                  <h4 className="text-[#1E63AD] w-[68px] text-[54px] leading-[54px]  text-center font-bold mob:text-[40px] mob:leading-[48px] mob:w-[44px] ">
                    24
                  </h4>
                  <div className=" text-[#0C2340]">
                    <p className="text-[24px] font-bold mob:leading-[28px] leading-[25px]">
                      Months
                    </p>
                    <p className=" text-sm font-semibold  ">
                      Special Financing*
                    </p>
                  </div>
                </div>
                <div className=" border-l border-[#707070] text-[15px] leading-[20px] text-[#0C2340] px-5 py-[3px] flex item-center mob:border-t  mob:border-l-0 mob:pt-[10px] mob:pl-0 items-start flex-col">
                  <p>For appliance purchases of $4,999+</p>
                  <span className="text-[13px]">(Only for Dacor /
                    JennAir / Monogram / Signature Kitchen Suite / Thermador)</span>
                </div>
              </li>
            </ul>
            <div className="text-[#374151] text-[14px] flex-1">
              <p className="font-bold mb-[10px] text-black">
                No Interest if paid in full within 6, 12, 18 or 24 Months*
              </p>
              <p className="mb-[10px]">
                *On qualifying in-store purchases made with your Synchrony Home
                credit card. Interest will be charged to your account from the
                purchase date if the promotional balance is not paid in full
                within 6, 12, 18 or 24 months. Minimum monthly payments
                required.
              </p>
              <p className="mb-[10px]">
                Qualifying purchase amount must be on one receipt. No interest
                will be charged on the promo balance if you pay it off, in full,
                within the promo period. If you do not,  interest will be
                charged on the promo balance from the purchase date.  The
                required minimum monthly payments may or may not pay off the
                promo balance before the end of the promo period, depending on
                purchase amount, promo length and payment allocation. Regular
                account terms apply to non-promo purchases and, after promo
                period ends, to the promo balance. New Accounts as of 7/16/24:
                Purchase APR 34.99%. Penalty APR 39.99%. Min Interest Charge $2.
                A promo fee will be charged equal to 2% of the amount financed
                on an equal payment no interest promotion of 18 months or more.
                Existing cardholders: See your credit card agreement terms.
                Subject to credit approval. We reserve the right to discontinue
                or alter the terms of this offer any time.
              </p>
              <div className="mt-[15px] flex items-center justify-center">
                <Link
                  href="https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=3CFA7859F753366BE02E1E21C94C49774DC4EEC45262EB74&client=Airport%20Appliance"
                  target="_blank"
                  className="bg-[#0C2340] text-white py-[10px] px-6 rounded-[20px] text-[12px] font-semibold "
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FinancingPage;